module.exports = __webpack_public_path__ + "static/media/shape-U.c129d39f.svg";